module.exports = __webpack_public_path__ + "static/media/Amelia_Island_FL_History_Museum_Spanish_dock_mural_installed_detail.8d6f4413.webp";